const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:7777/api';

export class SpeakerAudioService {
  static async fetchSpeakerSampleUrl(
    transcriptionChecksum: string,
    speakerId: number,
    token?: string
  ): Promise<string> {
    const headers: Record<string, string> = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(
      `${API_BASE_URL}/audio/${encodeURIComponent(transcriptionChecksum)}/speaker-sample/${speakerId}`,
      {
        headers,
        redirect: 'follow'
      }
    );

    if (!response.ok) {
      throw new Error(`Audio playback failed: HTTP ${response.status}`);
    }

    const audioBlob = await response.blob();
    if (!audioBlob.size) {
      throw new Error('Speaker sample was empty');
    }

    return URL.createObjectURL(audioBlob);
  }
}

export default SpeakerAudioService;
